import { LoginResponseDto } from './LoginDtos';
import { Auth } from '@spike/auth-model';

export const convert = (dto: LoginResponseDto, signedIn: boolean): Auth => {
    const work = dto.marketplaces.find(marketplaceDto => marketplaceDto.id === dto.marketplace.id)!;

    return {
        user: {
            id: dto.user.id,
            firstName: dto.user.first_name,
            lastName: dto.user.last_name,
            avatar: dto.user.image,
            email: dto.user.email,
            staffId: dto.user.staff_id,
            role: {
                ...dto.master_data.roles.find(roleDto => roleDto.id === work.role_id)!
            }
        },
        signedIn,
        token: dto.user.token,
        marketplaceId: dto.marketplace.id,
        addressId: dto.marketplace.addresses[0].id,
        timeZone: dto.time_zone,
        marketplaces: dto.marketplaces.map(mktp => ({
            id: mktp.id,
            name: mktp.name,
            city: mktp.city,
            addressId: mktp.address_id,
            timeZone: mktp.time_zone,
            role: {
                ...dto.master_data.roles.find(roleDto => roleDto.id === mktp.role_id)!
            },
            active: mktp.active
        })),
        version: process.env.REACT_APP_VERSION
    };
};
